import styled from "styled-components";
import { PageBox } from "../../../../../styles/page";

export const SolutionTableContent = styled.div`
  display: flex;
  flex-direction: column;

  .no {
    width: 4%;
  }
  .type {
    width: 8%;
  }
  .title {
    width: 22%;
  }
  .time {
    width: 9%;
  }
  .price {
    width: 13%;
  }
  .button {
    width: 10%;
  }
  .min {
    width: 8%;
  }
`;

export const SolutionListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const SolutionTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 5px 15px;
  box-sizing: border-box;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 45px;
    color: #121212;
    font-family: Pretendard;
    font-size: 12.5px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
  }
`;

export const SolutionTableItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  height: 40px;
  padding: 5px 15px;
  box-sizing: border-box;
  border-radius: 13.94px;
  background: #ecf0f3;

  > .item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Pretendard;
    font-size: 12px;
    font-weight: 500;
  }

  > .item.title {
    > span {
      padding: 6px 12px;
      border-radius: 7px;
      background: linear-gradient(
        103.15deg,
        #6c36d6 -22.02%,
        #955fff 54.56%,
        #ccb2ff 102.58%
      );
      color: #fff;
    }
  }
  > .item.button {
    > span {
      padding: 6px 12px;
      border-radius: 7px;
      background: #7f25fb;
      color: #fff;
      cursor: pointer;
    }
  }
`;

export const SolutionPointWrapper = styled(PageBox)<{ isWide: boolean }>`
  width: ${({ isWide }) => (isWide ? "352px" : "100%")};
  padding: ${({ isWide }) => (isWide ? "20px 23px" : "20px 10px 10px")};

  > .header {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    > .date {
      font-family: Pretendard;
      font-weight: 700;
      font-size: 15px;
      line-height: 100%;
    }
  }
`;

export const SolutionPointButton = styled.div<{ type?: string }>`
  width: 100%;
  height: 50px;
  border-radius: 15px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 15px;
  line-height: 50px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  background: ${(p) => (p.type === "gray" ? `#bebebe` : "#7f25fb")};

  &:last-child,
  &:nth-child(3) {
    grid-column: span 2;
  }
`;

export const SolutionPointButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 49px;
  gap: 10px 12px;
`;

export const SolutionPointDataWrapper = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  > .date {
    font-family: Pretendard;
    font-weight: 700;
    font-size: 15px;
  }
`;

export const SolutionPointDataItem = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: Pretendard;
  font-size: 15px;

  > .name {
    font-weight: 500;
  }

  > .value {
    font-weight: 700;

    > span {
      font-weight: 600;
      font-size: 13px;
    }
  }
`;

export const SolutionPointHeader = styled.div<{ type: string }>`
  display: flex;
  flex-direction: ${(p) => (p.type === "POINT" ? "column" : "row")};
  flex-wrap: ${(p) => (p.type === "POINT" ? "nowrap" : "wrap")};
  gap: ${(p) => (p.type === "POINT" ? "20px" : "10px")};
  margin-top: 20px;
  border-radius: 8px;
  background: #ecf0f3;
  padding: 20px 16px;
  gap: 5px;
`;

export const SolutionPointHeaderItem = styled.div<{ type: string }>`
  display: flex;
  gap: 3px;
  flex-direction: ${(p) => (p.type === "POINT" ? "row" : "column")};
  flex: ${(p) => (p.type === "POINT" ? "1" : "0 1 calc(50% - 5px)")};

  > .name {
    font-family: Pretendard;
    font-weight: ${(p) => (p.type === "POINT" ? "500" : "700")};
    font-size: ${(p) => (p.type === "POINT" ? "15px" : "15px")};
  }

  > .value {
    font-family: Pretendard;
    font-weight: 700;
    font-size: ${(p) => (p.type === "POINT" ? "15" : "20")}px;
    display: flex;
    flex-direction: column;

    &.red {
      color: #ff0000;
    }
    &.purple {
      color: #7f25fb;
    }
  }

  ${(p) =>
    p.type !== "POINT" &&
    `
      &:first-child {
        flex: 0 0 100%;
        gap: 5px;
      }
      &:not(:first-child) > .name {
        font-size: 11px;
        color:rgb(80, 80, 80);
      }
      &:not(:first-child) > .value {
        font-size: 13px;
        color:rgb(59, 59, 59);
      }
    `}
`;
